import { render, staticRenderFns } from "./AreaSearchResultBeautify.vue?vue&type=template&id=0794e568&scoped=true"
import script from "./AreaSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./AreaSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./AreaSearchResultBeautify.vue?vue&type=style&index=0&id=0794e568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794e568",
  null
  
)

export default component.exports